module.exports = __webpack_public_path__ + "static/img/son8_active.4781aa2b.png";